
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import NotificationItem from './NotificationItem.vue';
import { Notification } from './types.ts';

export default defineComponent({
  name: 'NotificationContainer',
  components: {
    NotificationItem,
  },
  computed: {
    ...mapState(['notifications']),
    
    visibleNotifications(): Notification[] {
      // Sort by timestamp (newest first) and limit to max visible
      return this.notifications
        .slice()
        .sort((a: Notification, b: Notification) => b.timestamp - a.timestamp)
        .slice(0, this.maxVisible);
    },
    
    maxVisible(): number {
      // Responsive max visible notifications
      if (this.$vuetify?.breakpoint?.xs) return 2;
      if (this.$vuetify?.breakpoint?.sm) return 3;
      return 4;
    },
  },
  methods: {
    handleDismiss(id: string) {
      this.$store.commit('REMOVE_NOTIFICATION', id);
    },
    
    handleClick(notification: Notification) {
      // Mark as read when clicked
      if (!notification.read) {
        this.$store.commit('MARK_NOTIFICATION_READ', notification.id);
      }
    },
  },
});
